import React from 'react';
import { motion } from 'framer-motion';
import { LineChart, MessageCircle, Calendar, Layout } from 'lucide-react';
export function HeroMockup() {
  return <div className="relative w-full max-w-[600px] aspect-[4/5] mx-auto px-4 sm:px-0" data-id="element-168">
      <motion.div className="absolute inset-x-4 sm:inset-x-0 inset-y-0 bg-neutral-900/60 backdrop-blur-xl rounded-2xl border border-white/10 shadow-2xl overflow-hidden flex flex-col" animate={{
      y: [-10, 10, -10]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-169">
        <div className="h-10 border-b border-white/10 flex items-center px-4 space-x-2 bg-white/[0.03] shrink-0" data-id="element-170">
          <div className="w-2.5 h-2.5 rounded-full bg-red-400/60" data-id="element-171"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-yellow-400/60" data-id="element-172"></div>
          <div className="w-2.5 h-2.5 rounded-full bg-green-400/60" data-id="element-173"></div>
          <div className="ml-4 flex-1 h-5 bg-white/[0.05] rounded-md border border-white/5 flex items-center px-3" data-id="element-174">
            <Layout size={11} className="text-neutral-500" data-id="element-175" />
            <div className="ml-2 text-[10px] text-neutral-400 font-medium tracking-wide" data-id="element-176">
              tunegocio.com
            </div>
          </div>
        </div>

        <div className="flex-1 relative overflow-hidden bg-neutral-900" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/iLuQQWuLr9nFozxCX5qp6L/ChatGPT_Image_29_may_2026,_19_41_32.png" alt="Premium website preview" className="absolute inset-0 w-full h-full object-cover object-center" fetchPriority="high" decoding="async" data-id="element-178" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" data-id="element-179"></div>

          <div className="absolute inset-0 p-4 pb-32 sm:p-6 flex flex-col justify-end" data-id="element-180">
            <div className="text-white" data-id="element-181">
              <div className="text-xl sm:text-2xl font-bold tracking-tight leading-tight mb-3" data-id="element-182">
                Llevá tu negocio
                <br data-id="element-183" />
                al siguiente nivel
              </div>
              <div className="hidden sm:inline-flex items-center px-4 py-2 bg-white text-black text-xs font-semibold rounded-full" data-id="element-184">
                Agendar asesoría
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Visitas card — hidden on small mobile, shown sm+ */}
      <motion.div className="hidden sm:block absolute -right-2 lg:-right-8 top-16 w-44 lg:w-48 bg-neutral-950/90 backdrop-blur-xl border border-white/10 rounded-xl p-4 shadow-[0_8px_32px_rgba(0,0,0,0.5)] z-30" animate={{
      y: [10, -10, 10]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} data-id="element-185">
        <div className="flex items-center justify-between mb-3" data-id="element-186">
          <div className="text-xs font-medium text-neutral-400" data-id="element-187">Visitas</div>
          <LineChart size={14} className="text-neon" data-id="element-188" />
        </div>
        <div className="text-xl font-bold text-white mb-2" data-id="element-189">+342%</div>
        <svg className="w-full h-8" viewBox="0 0 100 30" preserveAspectRatio="none" data-id="element-190">
          <path d="M0,30 L20,20 L40,25 L60,10 L80,15 L100,0" fill="none" stroke="url(#neonGradient)" strokeWidth="2" data-id="element-191" />
          <defs data-id="element-192">
            <linearGradient id="neonGradient" x1="0%" y1="0%" x2="100%" y2="0%" data-id="element-193">
              <stop offset="0%" stopColor="#3B82F6" data-id="element-194" />
              <stop offset="100%" stopColor="#22D3EE" data-id="element-195" />
            </linearGradient>
          </defs>
        </svg>
      </motion.div>

      {/* WhatsApp card — TOP on mobile, middle-left on desktop (above the inner text, below WHATSAPP badge) */}
      <motion.div className="absolute top-16 left-1 sm:top-auto sm:left-auto sm:-left-6 lg:-left-10 sm:bottom-48 w-44 sm:w-52 lg:w-56 bg-neutral-950/90 backdrop-blur-xl border border-white/10 rounded-xl p-3 sm:p-4 shadow-[0_8px_32px_rgba(0,0,0,0.5)] flex items-start space-x-3 z-30" animate={{
      y: [-15, 15, -15]
    }} transition={{
      duration: 7,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-196">
        <div className="w-8 h-8 rounded-full bg-green-500/15 flex items-center justify-center shrink-0" data-id="element-197">
          <MessageCircle size={16} className="text-green-400" data-id="element-198" />
        </div>
        <div className="min-w-0" data-id="element-199">
          <div className="text-xs font-medium text-white mb-1" data-id="element-200">
            Nuevo mensaje
          </div>
          <div className="text-[10px] text-neutral-400 truncate" data-id="element-201">
            "Hola, quiero reservar..."
          </div>
        </div>
      </motion.div>

      {/* Reservation card */}
      <motion.div className="absolute -right-1 sm:-right-2 lg:-right-4 -bottom-16 sm:bottom-12 w-48 sm:w-52 bg-neutral-950/90 backdrop-blur-xl border border-white/10 rounded-xl p-3 sm:p-3.5 shadow-[0_8px_32px_rgba(0,0,0,0.5)] z-30" animate={{
      y: [12, -12, 12]
    }} transition={{
      duration: 6.5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.5
    }} data-id="element-202">
        <div className="flex items-center space-x-2 mb-3" data-id="element-203">
          <div className="w-6 h-6 rounded-full bg-green-500/15 flex items-center justify-center" data-id="element-204">
            <Calendar size={12} className="text-green-400" data-id="element-205" />
          </div>
          <div className="text-[11px] font-semibold text-white" data-id="element-206">
            Reserva Confirmada
          </div>
        </div>

        <div className="space-y-1.5 mb-3" data-id="element-207">
          <div className="flex items-center justify-between text-[10px]" data-id="element-208">
            <span className="text-neutral-500" data-id="element-209">Cliente</span>
            <span className="text-white font-medium" data-id="element-210">María G.</span>
          </div>
          <div className="flex items-center justify-between text-[10px]" data-id="element-211">
            <span className="text-neutral-500" data-id="element-212">Fecha</span>
            <span className="text-white font-medium" data-id="element-213">Vie 14 · 21:00</span>
          </div>
          <div className="flex items-center justify-between text-[10px]" data-id="element-214">
            <span className="text-neutral-500" data-id="element-215">Mesa</span>
            <span className="text-white font-medium" data-id="element-216">4 personas</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-white/10" data-id="element-217">
          <div className="flex items-center space-x-1" data-id="element-218">
            <span className="relative flex h-1.5 w-1.5" data-id="element-219">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-220"></span>
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-green-400" data-id="element-221"></span>
            </span>
            <span className="text-[9px] text-green-400 font-medium uppercase tracking-wider" data-id="element-222">
              Pagada
            </span>
          </div>
          <span className="text-[10px] font-bold text-white" data-id="element-223">$8.400</span>
        </div>
      </motion.div>
    </div>;
}